import type { FC } from 'react';
import AdsHistoryPage from './AdsHistoryPage';

const TestingHistoryByAdsPage: FC = () => (
  <AdsHistoryPage marketingProcess="testing" embedded />
);

export default TestingHistoryByAdsPage;
